import {
  CREATE_KITCHEN_REQUEST,
  CREATE_KITCHEN_SUCCESS,
  CREATE_KITCHEN_FAILURE,
} from "../actions/kitchenActions";

/* ================================
   INITIAL STATE
================================ */
const initialState = {
  loading: false,
  kitchen: null,
  success: false,
  error: null,
};

/* ================================
   KITCHEN REDUCER
================================ */
const kitchenReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_KITCHEN_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_KITCHEN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        kitchen: action.payload,
        error: null,
      };

    case CREATE_KITCHEN_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default kitchenReducer;
